import {FormStep} from '../../../constants'

export interface CouponInputProps {
  mobile?: boolean
  currentStep: FormStep
}

export enum CouponFormState {
  INITIAL = 'INITIAL',
  EDIT = 'EDIT',
  APPLIED = 'APPLIED',
}
